import shareType from '../../../constants-v2/crm/share-type';
import partnerCrmApprovalRequestStatus from '../../../constants-v2/partner-crm/partner-crm-approval-request-status';
import companyPhone from '../../../filters/company/company-phone';
import personFullName from '../../../filters/person/person-full-name';
import { moneyFormatToSting } from '../../../helpers/MoneyHelpers';
import routeName from '../../../routes/route-name';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export default {
  actions,
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100,
    }),
  },
  columns: {
    fullName: column({ label: 'Imię i nazwisko', format: item => personFullName(item?.crm?.client?.person) }),
    phone: column({ label: 'Telefon', format: item => companyPhone(item?.crm?.client?.person?.company) }),
    email: column({ label: 'E-mail', format: item => item?.crm?.client?.person?.login_email }),
    shares: column({
      label: 'Posiadane udziały',
      component: 'value-status-tooltips',
      items: ({ item }) => item?.share?.map(e => ({
        label: `${ moneyFormatToSting(e.value) }${ shareType.PERCENTAGE === e.sharetype ? ' %' : '' }`,
        tooltip: `Od: ${ e.valid_from || '-' } / Do: ${ e.valid_to || '-' }`,
      })),
    }),
    status: column({
      label: 'Status powiązań',
      component: 'value-status',
      options: {
        1: { label: 'Powiązano', value: partnerCrmApprovalRequestStatus.approved, color: 'success' },
        2: { label: 'Oczekuje', value: partnerCrmApprovalRequestStatus.pending, color: 'gray' },
        3: { label: 'Odrzucono', value: partnerCrmApprovalRequestStatus.rejected, color: 'danger' },
      },
      format: item => item.partnercrmapprovalrequest?.[0]?.status,
      filter: item => true,
    }),
  },
  vars: vars({
    noItemsText: 'Brak wspólników',
    sidebarLabel: 'Podgląd szablonu',
    softDelete: {
      title: 'Usunięcie wspólnika',
      text: (item) => `Czy na pewno chcesz usunąć wspólnika ${ personFullName(item?.crm?.client?.person) }?`,
      successText: 'Wspólnik został usunięty.',
    },
  }),
  topRightActions: {
    create: {
      label: 'Dodaj wspólnika',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.replace({ name: routeName.crmPartner.store }),
    },
  },
};
